module.exports = __webpack_public_path__ + "static/media/pg28.a1116176.jpg";